module.exports = __webpack_public_path__ + "static/img/play.d1e477d2.png";